import { c as _c } from "react/compiler-runtime";
import { CollectionNavigationSkeleton } from "@/components/collection/CollectionNavigationSkeleton";
import { CollectionDropProvider } from "@/components/collection/drops/components/CollectionDropContext";
import { CollectionHeaderSkeleton } from "@/components/collection/header/CollectionHeaderSkeleton";
import { HeroHeaderViewProviderSkeleton } from "@/components/hero-header/HeroHeaderViewProvider";
export function CollectionPageLayoutSkeleton(t0) {
  const $ = _c(7);
  const {
    children,
    heroHeaderView
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <CollectionHeaderSkeleton />;
    t2 = <CollectionNavigationSkeleton />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <main>{children}</main>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== heroHeaderView || $[5] !== t3) {
    t4 = <CollectionDropProvider><HeroHeaderViewProviderSkeleton headerView={heroHeaderView}>{t1}{t2}{t3}</HeroHeaderViewProviderSkeleton></CollectionDropProvider>;
    $[4] = heroHeaderView;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}